// Use window.Configurator to avoid redeclaration errors
if (typeof window.Configurator === 'undefined') {
    window.Configurator = class Configurator {
        constructor() {

            this.configuratorElement = document.querySelector('.configurator');
            this.overlayButtons = this.configuratorElement.querySelectorAll('button[data-overlay]');
            this.closeOverlayButton = this.configuratorElement.querySelector('.js-close-overlay');
            this.applyButton = this.configuratorElement.querySelector('.js-apply');
            this.doneButton = this.configuratorElement.querySelector('.js-done');
            this.addToCartButton = this.configuratorElement.querySelector('.js-add-to-cart');
            this.swiper = null;
            this.currentOverlayType = null;
            this.savedSelections = {}; // Confirmed selections
            this.tempSelections = {}; // Temporary selections in overlay
            this.priceContainer = this.configuratorElement.querySelector('.js-price');
            this.finalPriceContainer = this.configuratorElement.querySelector('.js-final-price');
            this.bundleItems = []; // Final bundle details
            this.labelMap = {
                'model': 'Model',
                'shell': 'Shell',
                'handle_color': 'Handle',
                'wheel_caps': 'Wheel Caps',
                'luggage_tag': 'Luggage tag',
                'monogram': 'Monogram'
            };

            // Cloudinary configuration
            this.cloudinaryConfig = {
                folder: 'horiznid',
                version: '50',
                cloudName: 'horizn-studios',
                baseUrl: 'https://res.horizn-studios.com'
            };

            if (this.configuratorElement) {
                this.configuratorElement.configuratorInstance = this;
            }

            this.init();
        }


        init() {
            this.setDefaultSelections();
            this.setTempSelections();
            this.bindEvents();
            this.checkSwiperState();
            // Initialize monogram preview with saved value
            this.setMonogramToInputs(this.savedSelections['monogram'] || '');
            this.updateMonogramPreview();
            this.updatePreviewImages();
            this.syncLuggageTagSwatchUI();
        }

        setActiveSwatches() {
            console.log('setActiveSwatches', this.savedSelections['model_slug']);
            const swatchesContainers = document.querySelectorAll(`.model--${this.savedSelections['model_slug']}`);
            swatchesContainers.forEach(container => {
                const swatches = container.querySelectorAll('.configurator-color-picker__swatch');

                swatches.forEach(swatch => {

                    if (swatch.getAttribute('data-sku').toLowerCase() === this.savedSelections['shell']) {
                        swatch.querySelector('span').classList.add('configurator-color-picker__swatch-color--active');
                    }
                    if (swatch.getAttribute('data-sku').toLowerCase() === this.savedSelections['handle_color']) {
                        swatch.querySelector('span').classList.add('configurator-color-picker__swatch-color--active');
                    }
                    if (swatch.getAttribute('data-sku').toLowerCase() === this.savedSelections['wheel_caps']) {
                        swatch.querySelector('span').classList.add('configurator-color-picker__swatch-color--active');
                    }
                    if (swatch.getAttribute('data-option-name') === 'luggage_tag') {
                        if (this.savedSelections['luggage_tag']) {
                            if (swatch.getAttribute('data-sku').toLowerCase() === this.savedSelections['luggage_tag'].toLowerCase()) {
                                swatch.querySelector('span').classList.add('configurator-color-picker__swatch-color--active');
                            }
                        } else if (swatch.hasAttribute('data-default')) {
                            swatch.querySelector('span').classList.add('configurator-color-picker__swatch-color--active');
                        }
                    }
                });
            });
        }

        setDefaultSelections() {
            this.savedSelections['model_slug'] = this.configuratorElement.dataset.currentHandle;
            this.savedSelections['model'] = this.configuratorElement.dataset.currentModelSku;;
            this.savedSelections['shell'] = this.configuratorElement.dataset.currentSku;
            this.savedSelections['handle_color'] = '';
            this.savedSelections['wheel_caps'] = '';
            this.savedSelections['luggage_tag'] = '';
            console.log(this.configuratorElement.dataset)
            this.setActiveSwatches();
            console.log('Default selections set:', this.savedSelections);
        }

        setTempSelections() {
            this.tempSelections['model_slug'] = this.configuratorElement.dataset.currentHandle;
            this.tempSelections['model'] = this.configuratorElement.dataset.currentSku;;
            this.tempSelections['shell'] = this.configuratorElement.dataset.currentSku;
            this.tempSelections['handle_color'] = '';
            this.tempSelections['wheel_caps'] = '';
            this.tempSelections['luggage_tag'] = '';

            console.log('Temporary selections set:', this.tempSelections);
        }


        bindModelButtonEvents() {
            const modelButtons = document.querySelectorAll('.configurator__model_switch .model-panel__button');

            modelButtons.forEach(button => {
                button.addEventListener('click', () => {

                    console.log('model button clicked', button.getAttribute('data-model-slug'));

                    modelButtons.forEach(btn => btn.classList.remove('model-panel__button--selected'));
                    button.classList.add('model-panel__button--selected');

                    const modelSKU = button.getAttribute('data-sku');

                    if (this.currentOverlayType === 'model') {
                        if (modelSKU) {
                            this.tempSelections['shell'] = modelSKU;
                            this.tempSelections['model'] = modelSKU;
                            this.tempSelections['model_slug'] = button.getAttribute('data-model-slug');
                            // this.tempSelections['handle_color'] = '';
                            // this.tempSelections['wheel_caps'] = '';
                            // this.tempSelections['luggage_tag'] = '';

                            this.updatePreviewImagesWithTemp();
                            this.syncLuggageTagSwatchVisibility(this.tempSelections['shell']);
                        }
                    }
                });
            });
        }

        bindMonogramEvents() {
            // Use event delegation for inputs and clear button to handle dynamically loaded content
            const configuratorElement = this.configuratorElement;

            // Handle input changes using delegation
            configuratorElement.addEventListener('input', (e) => {
                if (e.target.classList.contains('monogram-text-input__field')) {
                    const input = e.target;
                    const allInputs = document.querySelectorAll('.monogram-text-input__field');
                    const index = Array.from(allInputs).indexOf(input);

                    // Allow only letters (a-z, A-Z)
                    const allowedChars = /[^a-zA-Z]/g;
                    input.value = input.value.replace(allowedChars, '').toUpperCase();

                    // Auto-focus next input
                    if (input.value.length && index < allInputs.length - 1) {
                        allInputs[index + 1].focus();
                    }

                    // Update preview on live
                    this.updateMonogramPreview();

                    // Update temp selection
                    if (this.currentOverlayType === 'monogram') {
                        this.updateMonogramTempSelection();
                        // Update images with luggage_tag when monogram is being typed
                        this.updatePreviewImagesWithTemp();
                    }
                }
            });

            // Handle backspace using delegation
            configuratorElement.addEventListener('keydown', (e) => {
                if (e.target.classList.contains('monogram-text-input__field') && e.key === 'Backspace' && !e.target.value) {
                    const allInputs = document.querySelectorAll('.monogram-text-input__field');
                    const index = Array.from(allInputs).indexOf(e.target);
                    if (index > 0) {
                        allInputs[index - 1].focus();
                    }
                }
            });

            // Handle clear button using delegation
            configuratorElement.addEventListener('click', (e) => {
                if (e.target.closest('.monogram-text-input__clear')) {
                    e.preventDefault();
                    e.stopPropagation();

                    // Find inputs in the monogram overlay
                    const monogramOverlay = document.querySelector('.configurator__overlay-content-monogram');
                    const monogramInputs = monogramOverlay
                        ? monogramOverlay.querySelectorAll('.monogram-text-input__field')
                        : document.querySelectorAll('.monogram-text-input__field');

                    // Clear inputs
                    monogramInputs.forEach(input => {
                        input.value = '';
                    });

                    // Clear from preview (image)
                    this.updateMonogramPreview();

                    // Clear from saved state
                    this.savedSelections['monogram'] = '';
                    this.tempSelections['monogram'] = '';
                    this.savedSelections['monogram_product'] = '';
                    this.tempSelections['monogram_product'] = '';

                    // Update temp selection if in monogram overlay
                    if (this.currentOverlayType === 'monogram') {
                        this.updateMonogramTempSelection();
                        // Update images when monogram is cleared
                        this.updatePreviewImagesWithTemp();
                    }

                    console.log('Monogram cleared from all states', {
                        savedSelections: this.savedSelections['monogram'],
                        tempSelections: this.tempSelections['monogram']
                    });
                }
            });
        }

        updateMonogramPreview() {
            // Find inputs in the monogram overlay specifically
            const monogramOverlay = document.querySelector('.configurator__overlay-content-monogram');
            const monogramInputs = monogramOverlay
                ? monogramOverlay.querySelectorAll('.monogram-text-input__field')
                : document.querySelectorAll('.monogram-text-input__field');
            const monogramPreview = document.querySelectorAll('.customizer-preview__monogram-text');

            if (!monogramPreview) return;

            const monogramText = Array.from(monogramInputs)
                .map(input => input.value)
                .join('');

            monogramPreview.forEach(preview => preview.textContent = monogramText);
        }

        updateMonogramTempSelection() {
            const monogramInputs = document.querySelectorAll('.monogram-text-input__field');
            const monogramText = Array.from(monogramInputs)
                .map(input => input.value)
                .join('');

            this.tempSelections['monogram'] = monogramText;
            console.log('Monogram temp selection updated:', monogramText);
        }

        getMonogramFromInputs() {
            // Find inputs in the monogram overlay specifically
            const monogramOverlay = document.querySelector('.configurator__overlay-content-monogram');
            const monogramInputs = monogramOverlay
                ? monogramOverlay.querySelectorAll('.monogram-text-input__field')
                : document.querySelectorAll('.monogram-text-input__field');
            return Array.from(monogramInputs)
                .map(input => input.value)
                .join('');
        }

        setMonogramToInputs(monogramText) {
            // Find inputs in the monogram overlay specifically
            const monogramOverlay = document.querySelector('.configurator__overlay-content-monogram');
            const monogramInputs = monogramOverlay
                ? monogramOverlay.querySelectorAll('.monogram-text-input__field')
                : document.querySelectorAll('.monogram-text-input__field');

            if (!monogramInputs || monogramInputs.length === 0) {
                console.warn('Monogram inputs not found');
                return;
            }

            if (!monogramText) {
                monogramInputs.forEach(input => input.value = '');
                return;
            }

            const chars = monogramText.split('');
            monogramInputs.forEach((input, index) => {
                input.value = chars[index] || '';
            });

            console.log('Monogram set to inputs:', monogramText, 'Inputs found:', monogramInputs.length);
        }


        saveDefaultSelections() {
            // Save model
            const selectedModel = document.querySelector('.configurator__model_switch .model-panel__button--selected');
            if (selectedModel) {

                // Save temporary selections to saved selections
                this.tempSelections['model'] = selectedModel.getAttribute('data-sku');
                this.tempSelections['model_slug'] = selectedModel.getAttribute('data-model-slug');

                // Hide color swatches for other models
                const otherModelColorSwatches = document.querySelectorAll(`.model--details`);
                otherModelColorSwatches.forEach(swatch => {
                    swatch.style.display = 'none';
                });

                // Update color swatches for the selected model
                const modelColorSwatches = document.querySelectorAll(`.model--details.model--${this.savedSelections['model_slug']}`);
                modelColorSwatches.forEach(swatch => {
                    swatch.style.display = 'flex';
                });

            }

            // Save colors for each section
            const overlayTypes = ['shell', 'handle_color', 'wheel_caps', 'luggage_tag'];
            overlayTypes.forEach(overlayType => {
                const overlayContent = document.querySelector(`.configurator__overlay-content-${overlayType}`);
                if (overlayContent) {
                    const activeColor = overlayContent.querySelector('.configurator-color-picker__swatch-color--active');
                    if (activeColor) {
                        const colorButton = activeColor.closest('button');
                        const colorSKU = colorButton ? colorButton.getAttribute('data-sku') : null;
                        if (colorSKU) {
                            this.tempSelections[overlayType] = colorSKU;
                        }
                    }
                }
            });

            // Update images after saving default selections
            this.updatePreviewImages();
            // this.setActiveSwatches();
        }

        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
            this.checkSwiperState();
        }

        isMobile() {
            return window.innerWidth < 1024;
        }

        checkSwiperState() {

            if (!this.swiper) return;

            const hasOverlay = this.configuratorElement.classList.contains('configurator--is-overlay');
            const isMobile = this.isMobile();

            // if (hasOverlay || isMobile) {
            if (isMobile) {
                this.swiper.disable();
            } else {
                this.swiper.enable();
            }
        }

        toggleSwiper() {
            this.checkSwiperState();
        }

        toggleFullscreenSwiper() {
            const isFullscreen = this.configuratorElement.classList.contains('configurator--is-preview-fullscreen');

            if (isFullscreen) {
                this.swiper.disable();
                this.configuratorElement.classList.remove('configurator--is-preview-fullscreen');
            } else {
                this.swiper.enable();
                this.configuratorElement.classList.add('configurator--is-preview-fullscreen');
            }
        }

        bindEvents() {
            this.overlayButtons.forEach(button => {
                button.addEventListener('click', () => this.openOverlay(button));
            });

            this.closeOverlayButton.addEventListener('click', () => this.cancelOverlay());
            this.applyButton.addEventListener('click', () => this.applyOverlay());
            this.doneButton.addEventListener('click', () => this.buildBundleItems());
            this.addToCartButton.addEventListener('click', () => this.addToCart());

            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => this.checkSwiperState(), 150);
            });

            this.zoomButton = document.querySelector('.configurator__toolbar-zoom-button');
            this.zoomButton.addEventListener('click', () => this.toggleFullscreenSwiper());

            this.bindModelButtonEvents();
            this.bindMonogramEvents();

            // Handle color selection
            const colorPickers = document.querySelectorAll('.configurator-color-picker');
            colorPickers.forEach(picker => {
                const swatches = picker.querySelectorAll('.configurator-color-picker__swatch-color');
                swatches.forEach(swatch => {
                    swatch.addEventListener('click', (event) => {
                        // Check if the button is disabled
                        const colorButton = swatch.closest('button');
                        if (colorButton && colorButton.disabled) {
                            event.preventDefault();
                            event.stopPropagation();
                            return false;
                        }

                        // Remove active class from all colors in this picker
                        swatches.forEach(s => s.classList.remove('configurator-color-picker__swatch-color--active'));
                        // Add active class to clicked color
                        swatch.classList.add('configurator-color-picker__swatch-color--active');

                        // If we're in overlay, update temporary selection and images
                        if (this.currentOverlayType && this.currentOverlayType !== 'done' && this.currentOverlayType !== 'monogram') {
                            const colorSKU = colorButton ? colorButton.getAttribute('data-sku') : null;
                            console.log('Color clicked:', {
                                currentOverlayType: this.currentOverlayType,
                                colorButton: colorButton,
                                colorSKU: colorSKU,
                                tempSelectionsBefore: { ...this.tempSelections }
                            });
                            if (this.currentOverlayType === 'luggage_tag' && colorButton?.hasAttribute('data-default')) {
                                this.tempSelections['luggage_tag'] = '';
                                this.updatePreviewImagesWithTemp();
                            } else if (colorSKU) {
                                if (
                                    this.currentOverlayType === 'luggage_tag' &&
                                    this.isIncludedLuggageTagSku(colorSKU, this.tempSelections['shell'])
                                ) {
                                    this.tempSelections['luggage_tag'] = '';
                                } else {
                                    this.tempSelections[this.currentOverlayType] = colorSKU;
                                }
                                console.log('Updated tempSelections:', {
                                    [this.currentOverlayType]: this.tempSelections[this.currentOverlayType],
                                    tempSelectionsAfter: { ...this.tempSelections }
                                });
                                // Update images live with temporary selections
                                this.updatePreviewImagesWithTemp();

                                if (this.currentOverlayType === 'shell') {
                                    this.syncLuggageTagSwatchVisibility(this.tempSelections['shell']);
                                }
                            } else {
                                console.error('❌ colorSKU is null or undefined!', {
                                    colorButton: colorButton,
                                    hasDataSku: colorButton ? colorButton.hasAttribute('data-sku') : false
                                });
                            }
                        }

                        // console.log('selected color added')
                        // console.log('savedSelections', this.savedSelections)
                    });
                });
            });
        }

        openOverlay(button) {
            this.configuratorElement.classList.toggle('configurator--is-overlay');

            const overlayType = button.dataset.overlay;
            this.currentOverlayType = overlayType;
            const overlayContent = document.querySelector(`.configurator__overlay-content-${overlayType}`);

            console.log('clicked', overlayType);
            console.log(`.configurator__overlay-content-${overlayType}`)

            // Save current state before opening overlay
            // this.saveCurrentState(overlayType);

            // Initialize temporary selection as copy of current
            if (overlayType !== 'done') {
                this.configuratorElement.querySelector('.js-cancel').style.display = 'inline';
                this.configuratorElement.querySelector('.js-edit').style.display = 'none';

                if (overlayType === 'monogram') {
                    // Initialize monogram temp selection with saved value
                    this.tempSelections['monogram'] = this.savedSelections['monogram'] || '';
                } else {
                    this.tempSelections[overlayType] = this.savedSelections[overlayType];
                }
                console.log('📋 Initialized tempSelections for overlay:', {
                    overlayType,
                    tempSelections: { ...this.tempSelections },
                    savedSelections: { ...this.savedSelections }
                });
            }

            // Update summary when opening "done" overlay
            if (overlayType === 'done') {
                // show add to cart button
                this.addToCartButton.style.display = 'block';
                // hide apply button
                this.applyButton.style.display = 'none';
                // show .configurator__section--notes
                this.configuratorElement.querySelector('.configurator__section--notes').style.display = 'block';
                this.configuratorElement.querySelector('.js-cancel').style.display = 'none';
                this.configuratorElement.querySelector('.js-edit').style.display = 'inline';
                // update summary
                this.updateSummary();
            }

            // Generate colors dynamically for color overlays based on current model
            if (['shell', 'handle_color', 'wheel_caps', 'luggage_tag'].includes(overlayType)) {
                // this.generateColorsForPart(overlayType);
            }

            if (overlayType == 'wheel_caps') {
                const image = document.querySelector('.customizer-preview--front');
                image.classList.add('customizer-preview--zoom-wheelCaps');
            }

            if (overlayType == 'luggage_tag') {
                const image = document.querySelector('.customizer-preview--front');
                image.classList.add('customizer-preview--zoom-tag');
            }

            if (overlayType == 'monogram') {
                const image = document.querySelector('.customizer-preview--front');
                image.classList.add('customizer-preview--zoom-monogram');
            }

            if (overlayContent) {
                // console.log('overlayContent',overlayContent)
                overlayContent.style.display = 'block';
            }

            // Initialize monogram inputs after overlay is visible
            if (overlayType === 'monogram') {
                // Use requestAnimationFrame to ensure DOM is ready and overlay is visible
                requestAnimationFrame(() => {
                    const savedMonogram = this.savedSelections['monogram'] || '';
                    this.setMonogramToInputs(savedMonogram);
                    this.updateMonogramPreview();
                    console.log('Monogram initialized in overlay:', savedMonogram);
                });
            }

            if (overlayType === 'luggage_tag') {
                this.syncLuggageTagSwatchUI();
            }

            this.toggleSwiper();
        }

        saveCurrentState(overlayType) {
            // Save current state of selections for this overlay
            if (overlayType === 'model') {
                const selectedModel = document.querySelector('.configurator__model_switch .model-panel__button--selected');

                if (selectedModel) {
                    const modelSKU = selectedModel.getAttribute('data-sku');
                    const modelSlug = selectedModel.getAttribute('data-model-slug');
                    this.savedSelections['model'] = modelSKU;
                    this.savedSelections['model_slug'] = modelSlug;

                    // Hide color swatches for other models
                    const otherModelColorSwatches = document.querySelectorAll(`.model--details`);
                    otherModelColorSwatches.forEach(swatch => {
                        swatch.style.display = 'none';
                    });

                    // Update color swatches for the selected model
                    const modelColorSwatches = document.querySelectorAll(`.model--details.model--${this.savedSelections['model_slug']}`);
                    modelColorSwatches.forEach(swatch => {
                        swatch.style.display = 'flex';
                    });

                }
            } else if (overlayType === 'luggage_tag') {
                const overlayContent = document.querySelector('.configurator__overlay-content-luggage_tag');
                if (overlayContent) {
                    const activeColor = overlayContent.querySelector('.configurator-color-picker__swatch-color--active');
                    if (activeColor) {
                        const colorButton = activeColor.closest('button');
                        const colorSKU = colorButton ? colorButton.getAttribute('data-sku') : null;
                        const shellSKU = this.tempSelections['shell'] || this.savedSelections['shell'];

                        if (colorButton?.hasAttribute('data-default') || this.isIncludedLuggageTagSku(colorSKU, shellSKU)) {
                            this.savedSelections['luggage_tag'] = '';
                        } else {
                            this.savedSelections['luggage_tag'] = colorSKU;
                        }
                    }
                }
            } else if (overlayType !== 'monogram') {
                const overlayContent = document.querySelector(`.configurator__overlay-content-${overlayType}`);
                if (overlayContent) {
                    const activeColor = overlayContent.querySelector('.configurator-color-picker__swatch-color--active');
                    if (activeColor) {
                        const colorButton = activeColor.closest('button');
                        const colorSKU = colorButton ? colorButton.getAttribute('data-sku') : null;
                        this.savedSelections[overlayType] = colorSKU;
                    }
                }
            }
            console.log('Saved selection', overlayType, ':', this.savedSelections[overlayType]);
            console.log('Saved selection', 'model_slug', ':', this.savedSelections['model_slug']);
            this.setActiveSwatches();
        }

        restoreState(overlayType) {
            // console.log('restoreState', overlayType);
            console.log('savedSelections', this.savedSelections);
            console.log('tempSelections', this.tempSelections);

            // Restore saved state
            if (overlayType === 'model') {
                const modelButtons = document.querySelectorAll('.configurator__model_switch .model-panel__button');
                modelButtons.forEach(btn => btn.classList.remove('model-panel__button--selected'));

                if (this.savedSelections[overlayType]) {
                    console.log('savedSelections[overlayType]', this.savedSelections[overlayType]);

                    // Find button with matching SKU
                    modelButtons.forEach(btn => {
                        const btnSKU = btn.getAttribute('data-sku');
                        if (btnSKU === this.savedSelections[overlayType]) {
                            btn.classList.add('model-panel__button--selected');
                        }
                    });
                }
            } else {
                const overlayContent = document.querySelector(`.configurator__overlay-content-${overlayType}`);
                if (overlayContent) {
                    const swatches = overlayContent.querySelectorAll('.configurator-color-picker__swatch-color');
                    swatches.forEach(s => s.classList.remove('configurator-color-picker__swatch-color--active'));

                    if (this.savedSelections[overlayType]) {
                        // Find swatch with matching SKU
                        swatches.forEach(swatch => {
                            const colorButton = swatch.closest('button');
                            const colorSKU = colorButton ? colorButton.getAttribute('data-sku') : null;
                            if (colorSKU === this.savedSelections[overlayType]) {
                                swatch.classList.add('configurator-color-picker__swatch-color--active');
                            }
                        });
                    }
                }
            }
            // console.log('Restored selection for', overlayType, ':', this.savedSelections[overlayType]);
        }

        applyOverlay() {
            console.log('applyOverlay');
            this.saveCurrentState(this.currentOverlayType);

            const defaultSwatches = document.querySelectorAll(`.model--${this.tempSelections['model_slug']} .configurator-color-picker__swatch[data-default]`);
            if (defaultSwatches.length) {
                defaultSwatches.forEach(swatch => {
                    swatch.dataset.sku = this.tempSelections['shell'];
                });
            }

            // For model changes, also update savedSelections with tempSelections
            if (this.currentOverlayType === 'model') {
                this.savedSelections['model'] = this.tempSelections['model'];
                this.savedSelections['model_slug'] = this.tempSelections['model_slug'];
                this.savedSelections['shell'] = this.tempSelections['shell'];
                this.savedSelections['handle_color'] = this.tempSelections['handle_color'];
                this.savedSelections['wheel_caps'] = this.tempSelections['wheel_caps'];
                this.savedSelections['luggage_tag'] = this.tempSelections['luggage_tag'];
                if (this.isIncludedLuggageTagSku(this.savedSelections['luggage_tag'], this.savedSelections['shell'])) {
                    this.savedSelections['luggage_tag'] = '';
                }
            } else if (this.currentOverlayType === 'monogram') {
                const monogramText = this.getMonogramFromInputs();
                const monogramProductEl = document.querySelector('[data-option-name="monogram_product"]');

                this.savedSelections['monogram'] = monogramText;
                this.tempSelections['monogram'] = monogramText;

                if (monogramText !== '' && monogramProductEl) {
                    this.savedSelections['monogram_product'] = monogramProductEl.dataset.sku;
                    this.tempSelections['monogram_product'] = monogramProductEl.dataset.sku;
                } else {
                    this.savedSelections['monogram'] = '';
                    this.tempSelections['monogram'] = '';
                    this.savedSelections['monogram_product'] = '';
                    this.tempSelections['monogram_product'] = '';
                }

                this.setMonogramToInputs(monogramText);
                this.updateMonogramPreview();
                this.syncLuggageTagSwatchUI();
                console.log('Monogram saved:', monogramText);
            } else if (this.currentOverlayType === 'shell') {
                this.savedSelections['shell'] = this.tempSelections['shell'];
                if (this.isIncludedLuggageTagSku(this.savedSelections['luggage_tag'], this.savedSelections['shell'])) {
                    this.savedSelections['luggage_tag'] = '';
                }
            } else if (this.currentOverlayType === 'luggage_tag') {
                const tagSku = this.tempSelections['luggage_tag'];
                this.savedSelections['luggage_tag'] = this.isIncludedLuggageTagSku(tagSku, this.tempSelections['shell'])
                    ? ''
                    : tagSku;
            } else {
                if (this.currentOverlayType !== 'shell' && this.tempSelections[this.currentOverlayType] == this.tempSelections['shell']) {
                    this.savedSelections[this.currentOverlayType] = '';
                } else {
                    this.savedSelections[this.currentOverlayType] = this.tempSelections[this.currentOverlayType];
                }
            }

            this.syncLuggageTagSwatchUI();
            this.updateSummary();
            // Update images after applying changes
            this.updatePreviewImages();

            this.updatePriceDisplay();

            if (this.currentOverlayType === 'model') {
                // here move showing right swatches for the model
                // this.generateAllColorPickers();
            }

            this.closeOverlayView();
        }

        cancelOverlay() {
            console.log('cancelOverlay');
            // Cancel changes - restore previous state
            // Reset tempSelections to savedSelections for this overlay
            if (this.currentOverlayType === 'model') {
                // Reset model and all related selections
                this.tempSelections['model'] = this.savedSelections['model'];
                this.tempSelections['model_slug'] = this.savedSelections['model_slug'];
                this.tempSelections['shell'] = this.savedSelections['shell'];
                this.tempSelections['handle_color'] = this.savedSelections['handle_color'];
                this.tempSelections['wheel_caps'] = this.savedSelections['wheel_caps'];
                this.tempSelections['luggage_tag'] = this.savedSelections['luggage_tag'];
            } else if (this.currentOverlayType === 'monogram') {
                // Reset monogram to saved value
                this.tempSelections['monogram'] = this.savedSelections['monogram'] || '';
                this.setMonogramToInputs(this.tempSelections['monogram']);
                this.updateMonogramPreview();
            } else if (this.currentOverlayType === 'done') {
                this.addToCartButton.style.display = 'none';
                this.applyButton.style.display = 'block';
                this.configuratorElement.querySelector('.configurator__section--notes').style.display = 'none';
            } else {
                // Reset only the current overlay type
                this.tempSelections[this.currentOverlayType] = this.savedSelections[this.currentOverlayType];
            }

            // Restore UI state
            this.restoreState(this.currentOverlayType);

            // Restore images to previous state using saved selections
            this.updatePreviewImages();

            this.closeOverlayView();
        }

        updateSummary() {
            const summaryContainer = document.querySelector('.summary-panel__customizations');
            if (!summaryContainer) return;

            // Update headline with selected model
            const headline = document.querySelector('.configurator__overlay-content-done .configurator__headline .js-model');
            if (headline && this.savedSelections['model']) {
                const modelName = this.getModelNameFromSKU(this.savedSelections['model']);
                headline.textContent = modelName;
            }

            // Clear existing items (except total row)
            const existingRows = summaryContainer.querySelectorAll('.summary-panel__row:not(.summary-panel__row--total)');
            existingRows.forEach(row => row.remove());

            // Get total row to insert before it
            const totalRow = summaryContainer.querySelector('.summary-panel__row--total');

            // Generate rows for each saved selection
            Object.keys(this.savedSelections).forEach(overlayType => {
                if (overlayType === 'model_slug' || overlayType === 'model' || overlayType === 'monogram_product') return; // Skip model_slug

                const sku = this.savedSelections[overlayType];
                // Skip empty monogram
                if (!sku && overlayType !== 'monogram') return;
                if (overlayType === 'monogram' && !sku) return;

                const label = this.labelMap[overlayType] || overlayType;
                const row = document.createElement('div');
                row.className = 'summary-panel__row';

                // Get color for swatch (if it's a color selection)
                let swatchHTML = '';
                if (overlayType === 'monogram') {
                    // For monogram, use a default color swatch (Gunmetal Grey)
                    swatchHTML = `<span class="summary-panel__swatch" style="background-color: rgb(125, 124, 131);"></span> `;
                } else if (overlayType !== 'model') {
                    const overlayContent = document.querySelector(`.configurator__overlay-content-${overlayType}`);
                    if (overlayContent) {
                        const colorButton = overlayContent.querySelector(`button[data-sku="${sku}"]`);
                        if (colorButton) {
                            const colorSpan = colorButton.querySelector('.configurator-color-picker__swatch-color');
                            if (colorSpan) {
                                const bgColor = colorSpan.style.backgroundColor || colorSpan.getAttribute('style')?.match(/background-color:\s*([^;]+)/)?.[1];
                                if (bgColor) {
                                    swatchHTML = `<span class="summary-panel__swatch" style="background-color: ${bgColor};"></span> `;
                                }
                            }
                        }
                    }
                }

                // Get display name from SKU
                let displayName = sku;
                if (overlayType === 'model') {
                    displayName = this.getModelNameFromSKU(sku);
                } else if (overlayType === 'monogram') {
                    displayName = sku || '-';
                } else {
                    displayName = this.getColorNameFromSKU(sku, overlayType);
                }

                // Get price from SKU
                let priceStr = this.getVariantPriceFromSKU(overlayType, sku);
                if (overlayType === 'monogram') {
                    priceStr = this.getVariantPriceFromSKU('monogram_product', this.savedSelections['monogram_product']);
                }

                row.innerHTML = `
                <div class="summary-panel__customization">
                    ${swatchHTML}
                    <span class="summary-panel__text">${label} / ${displayName}</span>
                </div>
                <div class="summary-panel__text">${priceStr}</div>
            `;

                // Insert before total row
                if (totalRow) {
                    summaryContainer.insertBefore(row, totalRow);
                } else {
                    summaryContainer.appendChild(row);
                }
            });

            // console.log('Summary updated with:', this.savedSelections);
        }

        closeOverlayView() {
            // Ensure monogram stays in inputs before closing overlay (while overlay is still visible)
            if (this.currentOverlayType === 'monogram') {
                const savedMonogram = this.savedSelections['monogram'] || '';
                this.setMonogramToInputs(savedMonogram);
                this.updateMonogramPreview();
                console.log('Monogram set before closing overlay:', savedMonogram);
                console.log('savedSelections: ', this.savedSelections);
            }

            this.configuratorElement.classList.toggle('configurator--is-overlay');
            const overlayContents = document.querySelectorAll('.configurator__overlay-content-details');

            if (!this.closeOverlayButton.classList.contains('configurator--is-overlay')) {
                overlayContents.forEach(content => {
                    content.style.display = 'none';
                });
            }

            const image = document.querySelector('.customizer-preview.customizer-preview--front');
            // console.log('image', image);

            image.classList.forEach(cls => {
                if (cls.startsWith('customizer-preview--zoom-')) {
                    image.classList.remove(cls);
                }
            });

            this.toggleSwiper();
        }


        generateColorsForPart(partType, containerId = null) {

            console.log('🎨 generateColorsForPart called for:', partType);

            // console.log(`\n🎨 === STARTING generateColorsForPart for ${partType} ===`);

            // Map part types to their container IDs
            const containerIds = {
                'shell': 'shell-colors-container',
                'handle_color': 'handle-colors-container',
                'wheel_caps': 'wheel-colors-container',
                'luggage_tag': 'luggage-tag-colors-container'
            };

            const targetContainerId = containerId || containerIds[partType];
            // console.log(`🔍 Looking for container with ID: ${targetContainerId}`);
            const container = document.getElementById(targetContainerId);

            if (!container) {
                console.error(`❌ Color container not found for ${partType} (ID: ${targetContainerId})`);
                console.error(`🔍 Available containers in DOM:`, Array.from(document.querySelectorAll('[id*="colors-container"]')).map(el => el.id));
                return;
            }

            // console.log(`✅ Container found for ${partType}`);

            const modelName = this.savedSelections['model'] || 'H5 Essential';
            const model = this.normalizeModelName(modelName);



            // Clear existing colors
            container.innerHTML = '';

            // Get available colors for current model and part type
            const partColors = this.colorSKUMapping[model]?.[partType] || {};
            const allColorNames = Object.keys(partColors);
            console.log(`🔍 partColors for ${model}.${partType}:`, partColors);
            console.log(`🔍 allColorNames (${allColorNames.length}):`, allColorNames);

            // Show all colors (both active and inactive)
            const allColorsToShow = allColorNames;

            // console.log(`📊 Summary: ${allColorsToShow.length} total colors to display`);

            if (allColorsToShow.length === 0) {

                container.innerHTML = '<div class="configurator-color-picker__loading">No colors available...</div>';
                return;
            }

            // Update CSS class based on number of colors
            const itemsClass = `configurator-color-picker__colors--items-${allColorsToShow.length}`;
            container.className = `configurator-color-picker__colors ${itemsClass}`;

            // Determine if this part type should have glossy effect
            const glossyParts = ['shell'];
            const effectParts = ['handle_color'];

            // Generate color elements - for all colors (active and inactive)
            allColorsToShow.forEach(colorName => {
                const colorData = partColors[colorName];
                const isGlossy = glossyParts.includes(partType) && colorName.toLowerCase().includes('glossy');
                const hasEffect = effectParts.includes(partType);

                // Check if color is available
                let isAvailable = true;
                let sku = '';

                if (typeof colorData === 'string') {
                    // Legacy format - assume available
                    sku = colorData;
                    isAvailable = true;
                } else {
                    // New format with object
                    sku = colorData.sku || '';
                    isAvailable = colorData.quantity > 0 && colorData.available;
                }


                const colorElement = document.createElement('div');
                colorElement.className = 'configurator-color-picker__color';

                // Add inactive class if not available
                if (!isAvailable) {
                    colorElement.classList.add('configurator-color-picker__color--inactive');
                }

                // Get color from metaobject data or fallback to predefined mapping
                const colorValue = this.getColorValue(colorName, partType);

                // Build class list for swatch
                let swatchClasses = 'configurator-color-picker__swatch-color';
                if (isGlossy) swatchClasses += ' configurator-shiny-effect';
                if (hasEffect) swatchClasses += ' configurator-color-picker__swatch-color--effect';

                // Create button with disabled state if not available
                const buttonDisabled = !isAvailable ? 'disabled' : '';
                const buttonCursor = !isAvailable ? 'style="cursor: not-allowed;"' : '';

                colorElement.innerHTML = `
                <button class="configurator-color-picker__swatch" ${buttonDisabled} ${buttonCursor}>
                    <span title="${colorName}" 
                          class="${swatchClasses}"
                          style="background-color: ${colorValue};"></span>
                </button>
                <div class="configurator-color-picker__label">
                    ${colorName}${sku ? ` (${sku})` : ''}
                </div>
                ${!isAvailable ? '<div class="configurator-color-picker__label configurator-color-picker__label--soldout">SOLD OUT</div>' : ''}
            `;

                container.appendChild(colorElement);
            });

            // Re-bind events for new elements
            const newSwatches = container.querySelectorAll('.configurator-color-picker__swatch-color');
            newSwatches.forEach(swatch => {
                swatch.addEventListener('click', (event) => {
                    // Check if the button is disabled
                    const colorButton = swatch.closest('button');
                    if (colorButton && colorButton.disabled) {
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    }

                    // Remove active class from all colors in this picker
                    newSwatches.forEach(s => s.classList.remove('configurator-color-picker__swatch-color--active'));
                    // Add active class to clicked color
                    swatch.classList.add('configurator-color-picker__swatch-color--active');

                    // If we're in overlay, update temporary selection and images
                    if (this.currentOverlayType && this.currentOverlayType !== 'done' && this.currentOverlayType !== 'monogram') {
                        const colorSKU = colorButton ? colorButton.getAttribute('data-sku') : null;
                        if (colorSKU) {
                            this.tempSelections[this.currentOverlayType] = colorSKU;
                            // Update images live with temporary selections
                            this.updatePreviewImagesWithTemp();
                        }
                    }
                });
            });

        }


        // generateShellColors() {
        //     this.generateColorsForPart('shell');
        // }

        // generateAllColorPickers() {

        //     this.generateColorsForPart('shell');
        //     // console.log('🔍 About to generate handle_color colors...');
        //     this.generateColorsForPart('handle_color');
        //     // console.log('🔍 About to generate wheel_caps colors...');
        //     this.generateColorsForPart('wheel_caps');
        //     // console.log('🔍 About to generate luggage_tag colors...');
        //     this.generateColorsForPart('luggage_tag');
        //     // console.log('✅ All color pickers generated');
        // }

        /**
         * Gets color value (RGB/Hex) for a color name from current model data
         * @param {string} colorName - name of the color
         * @param {string} partType - part type (shell, handle, wheel, luggage-tag)
         * @returns {string} RGB/Hex color value
         */
        getColorValue(colorName, partType = 'shell') {
            const modelName = this.savedSelections['model'] || 'H5 Essential';
            const model = this.normalizeModelName(modelName);

            // Try to get color code from metaobject data
            const colorData = this.colorSKUMapping[model]?.[partType]?.[colorName];
            if (colorData && colorData.colorCode) {
                // Convert hex to rgb if needed
                if (colorData.colorCode.startsWith('#')) {
                    return this.hexToRgb(colorData.colorCode);
                }
                return colorData.colorCode;
            }

            // Fallback to hardcoded map for backwards compatibility
            const colorMap = {
                // Shell colors
                'All Black': 'rgb(0, 0, 0)',
                'Dark Olive': 'rgb(79, 79, 47)',
                'Glossy Dusk Yellow': 'rgb(255, 220, 100)',
                'Glossy Purple Night': 'rgb(60, 40, 80)',
                'Sand Grey': 'rgb(180, 170, 160)',
                'Coastal Blue': 'rgb(100, 150, 200)',
                'Night Blue': 'rgb(40, 60, 100)',
                'Glossy True Red': 'rgb(170, 24, 43)',
                'Glossy Blue Vega': 'rgb(138, 152, 172)',
                'Glossy Agave Green': 'rgb(110, 116, 110)',
                'Glossy All Black': 'rgb(0, 0, 0)',
                'All White': 'rgb(255, 255, 255)',
                'Grey Lavender': 'rgb(145, 141, 154)',
                'Light Quartz Grey': 'rgb(197, 195, 195)',
                'Glossy Graphite': 'rgb(60, 62, 65)',
                'Glossy Night Blue': 'rgb(44, 54, 66)',

                // Handle colors
                'True Red': 'rgb(170, 24, 43)',
                'Honey Love': 'rgb(245, 199, 26)',
                'Orange Glow': 'rgb(232, 115, 61)',
                'Blue Bolt': 'rgb(61, 98, 176)',
                'Teal Spark': 'rgb(90, 155, 163)',
                'Matcha High': 'rgb(160, 194, 61)',

                // Wheel & Luggage Tag colors
                'Purple Blaze': 'rgb(128, 115, 152)',
                'Flamingo Crush': 'rgb(199, 100, 145)'
            };

            return colorMap[colorName] || 'rgb(128, 128, 128)'; // Default grey
        }






        normalizeModelName(modelName) {
            if (!modelName) return 'h5';
            const normalized = modelName.toLowerCase();
            if (normalized.includes('h5')) return 'h5';
            if (normalized.includes('m5')) return 'm5';
            return 'h5';
        }

        normalizeColorNameForComparison(colorName) {
            if (!colorName) {
                return '';
            }

            return colorName.replace(/glossy/gi, '').replace(/\s+/g, ' ').trim().toLowerCase();
        }

        colorNamesMatch(colorNameA, colorNameB) {
            return this.normalizeColorNameForComparison(colorNameA) === this.normalizeColorNameForComparison(colorNameB);
        }

        getSwatchBySku(optionName, sku) {
            if (!sku) {
                return null;
            }

            return document.querySelector(
                `.configurator-color-picker__swatch[data-option-name="${optionName}"][data-sku="${sku}"]`
            );
        }

        getShellColorName(shellSku) {
            const shellSwatch = this.getSwatchBySku('shell', shellSku);
            return shellSwatch?.dataset.colorName || '';
        }

        getIncludedTagSkuForShell(shellSku) {
            const shellColorName = this.getShellColorName(shellSku);
            if (!shellColorName) {
                return '';
            }

            const tagSwatches = document.querySelectorAll(
                '.configurator-color-picker__swatch[data-option-name="luggage_tag"]:not([data-default])'
            );

            for (const swatch of tagSwatches) {
                if (this.colorNamesMatch(swatch.dataset.colorName, shellColorName)) {
                    return swatch.dataset.sku;
                }
            }

            return '';
        }

        isIncludedLuggageTagSku(tagSku, shellSku) {
            if (!tagSku) {
                return true;
            }

            const includedTagSku = this.getIncludedTagSkuForShell(shellSku);
            return includedTagSku !== '' && tagSku === includedTagSku;
        }

        getPreviewTagSku({ useTemp = false } = {}) {
            const shellSKU = useTemp
                ? (this.tempSelections['shell'] || this.savedSelections['shell'])
                : this.savedSelections['shell'];
            const paidTagSKU = useTemp
                ? this.tempSelections['luggage_tag']
                : this.savedSelections['luggage_tag'];

            if (paidTagSKU) {
                return paidTagSKU;
            }

            return this.getIncludedTagSkuForShell(shellSKU) || '';
        }

        syncLuggageTagSwatchVisibility(shellSku) {
            const shellSKU = shellSku || this.tempSelections['shell'] || this.savedSelections['shell'];
            const shellColorName = this.getShellColorName(shellSKU);
            const modelSlug = this.tempSelections['model_slug'] || this.savedSelections['model_slug'];
            const containers = modelSlug
                ? document.querySelectorAll(`.configurator-option--luggage_tag.model--${modelSlug}`)
                : document.querySelectorAll('.configurator-option--luggage_tag.model--details');

            containers.forEach((container) => {
                container.querySelectorAll('.configurator-color-picker__color').forEach((colorEl) => {
                    const button = colorEl.querySelector(
                        '.configurator-color-picker__swatch[data-option-name="luggage_tag"]:not([data-default])'
                    );

                    if (!button) {
                        return;
                    }

                    const hideMatchingShell = Boolean(
                        shellColorName && this.colorNamesMatch(button.dataset.colorName, shellColorName)
                    );
                    colorEl.style.display = hideMatchingShell ? 'none' : '';
                });
            });
        }

        syncLuggageTagSwatchUI() {
            const shellSKU = this.tempSelections['shell'] || this.savedSelections['shell'];
            this.syncLuggageTagSwatchVisibility(shellSKU);

            const overlay = document.querySelector('.configurator__overlay-content-luggage_tag');
            if (!overlay) {
                return;
            }

            const paidTagSKU = this.savedSelections['luggage_tag'];
            const defaultSwatch = overlay.querySelector('.configurator-color-picker__swatch[data-default]');
            const productSwatches = overlay.querySelectorAll('.configurator-color-picker__swatch:not([data-default])');

            productSwatches.forEach((button) => {
                button.querySelector('span')?.classList.remove('configurator-color-picker__swatch-color--active');
            });
            defaultSwatch?.querySelector('span')?.classList.remove('configurator-color-picker__swatch-color--active');

            if (defaultSwatch?.parentElement) {
                defaultSwatch.parentElement.style.display = 'flex';
            }

            if (paidTagSKU) {
                const paidButton = overlay.querySelector(`.configurator-color-picker__swatch[data-sku="${paidTagSKU}"]`);
                paidButton?.querySelector('span')?.classList.add('configurator-color-picker__swatch-color--active');
            } else if (defaultSwatch) {
                defaultSwatch.querySelector('span')?.classList.add('configurator-color-picker__swatch-color--active');
            }
        }

        getLuggageTagLabelForCart() {
            if (this.savedSelections['luggage_tag']) {
                return this.getVariantNameFromSKU(this.savedSelections['luggage_tag']);
            }

            const includedTagSku = this.getIncludedTagSkuForShell(this.savedSelections['shell']);
            if (includedTagSku) {
                return this.getColorNameFromSKU(includedTagSku, 'luggage_tag');
            }

            return '';
        }

        /**
         * Gets color name from SKU by searching DOM elements
         * @param {string} sku - SKU to find
         * @param {string} overlayType - overlay type (shell, handle_color, etc.)
         * @returns {string} color name or SKU if not found
         */
        getColorNameFromSKU(sku, overlayType) {
            if (!sku) return sku;

            const overlayContent = document.querySelector(`.configurator__overlay-content-${overlayType}`);
            if (overlayContent) {
                const colorButton = overlayContent.querySelector(`button[data-sku="${sku}"]`);
                if (colorButton) {
                    const colorSpan = colorButton.querySelector('.configurator-color-picker__swatch-color');
                    return colorSpan ? colorSpan.getAttribute('title') : sku;
                }
            }
            return sku;
        }

        /**
         * Gets model name from SKU by searching DOM elements
         * @param {string} sku - SKU to find
         * @returns {string} model name or SKU if not found
         */
        getModelNameFromSKU(sku) {
            if (!sku) return sku;

            const modelButton = document.querySelector(`.model-panel__button[data-sku="${sku}"]`);
            if (modelButton) {
                const titleElement = modelButton.querySelector('.model-panel__button-title');
                return titleElement ? titleElement.textContent.trim() : sku;
            }
            return sku;
        }

        getVariantNameFromSKU(sku) {
            if (!sku) return sku;
            const variantButton = document.querySelector(`.configurator-color-picker__swatch[data-sku="${sku}"]`);
            return variantButton.dataset.colorName ? variantButton.dataset.colorName : sku;
        }

        /**
         * Normalizes model name from SKU
         * @param {string} sku - SKU to normalize
         * @returns {string} normalized model name (h5 or m5)
         */
        normalizeModelNameFromSKU(sku) {
            if (!sku) return 'h5';
            const skuLower = sku.toLowerCase();
            if (skuLower.includes('h5') || skuLower.includes('hs7uax')) return 'h5';
            if (skuLower.includes('m5') || skuLower.includes('hs1dcd')) return 'm5';
            return 'h5';
        }


        getCloudinaryOverlaidImageUrl(baseImageId, overlayImageIds = [], options = {}) {
            const { width = '1.0', dpr = '1.0', format = 'jpg', background = 'f3f3f3' } = options;

            // Build transformations for overlays - replace / with : in overlay IDs
            const overlayParts = overlayImageIds
                .filter(id => id)
                .map(id => `l_${id.toLowerCase().replace(/\//g, ':')}`)
                .join('/');

            // Build final URL
            const transformations = [
                overlayParts,
                `b_rgb:${background},c_scale,dpr_${dpr},f_${format},w_${width}`
            ].filter(part => part).join('/');

            return `${this.cloudinaryConfig.baseUrl}/${transformations}/${baseImageId.toLowerCase()}.${format}`;
        }


        generateImageUrls() {
            const { folder, version } = this.cloudinaryConfig;

            // Get model
            console.log('generateImageUrls', this.savedSelections);
            const modelSKU = this.savedSelections['model'] || 'hs7uax';
            const model = this.normalizeModelNameFromSKU(modelSKU);

            console.log('model', model);

            // Photo angles
            const angles = ['front', '45degree', 'side', 'back'];

            // Get SKU for selected parts
            const shellSKU = this.savedSelections['shell'];
            const handleSKU = this.savedSelections['handle_color'];
            const wheelSKU = this.savedSelections['wheel_caps'];
            const tagSKU = this.getPreviewTagSku();

            // Generate URL for each angle
            const urls = {};

            angles.forEach(angle => {
                // Base image ID
                const baseImageId = `v${version}/${folder}/${model}-${angle}`;

                // Overlay image IDs - different parts are visible on different angles
                const overlayImageIds = [];

                // Shell is visible on all angles
                if (shellSKU) {
                    overlayImageIds.push(`v${version}/${folder}/${shellSKU}-${angle}`);
                }

                // Handle is visible on all angles including interior
                if (handleSKU) {
                    overlayImageIds.push(`v${version}/${folder}/${handleSKU}-${angle}`);
                }

                // Wheel caps are visible on all angles
                if (wheelSKU) {
                    overlayImageIds.push(`v${version}/${folder}/${wheelSKU}-${angle}`);
                }

                // Luggage tag is visible mainly on front and 45degree
                if (tagSKU && ['front', '45degree'].includes(angle)) {
                    overlayImageIds.push(`v${version}/${folder}/${tagSKU}-${angle}`);
                }

                urls[angle] = this.getCloudinaryOverlaidImageUrl(baseImageId, overlayImageIds);
            });

            return urls;
        }

        /**
         * Updates all preview images based on current selections
         */
        updatePreviewImages() {
            const urls = this.generateImageUrls();

            console.log('updatePreviewImages', urls);

            // Find all images and update them
            const previewImages = {
                front: document.querySelector('.customizer-preview--front .customizer-preview__image'),
                '45degree': document.querySelector('.customizer-preview--45degree .customizer-preview__image'),
                side: document.querySelector('.customizer-preview--side .customizer-preview__image'),
                back: document.querySelector('.customizer-preview--back .customizer-preview__image')
            };

            // Update each image
            Object.keys(previewImages).forEach(angle => {
                const img = previewImages[angle];
                if (img && urls[angle]) {
                    // Preload image before changing src to avoid flickering
                    const tempImage = new Image();
                    tempImage.onload = () => {
                        img.src = urls[angle];
                    };
                    tempImage.src = urls[angle];
                }
            });
        }


        updatePreviewImagesWithTemp() {

            // add loading spinner
            const loadingSpinner = document.createElement('div');
            loadingSpinner.classList.add('customizer-preview__loading-spinner');
            loadingSpinner.innerHTML = '<div class="loader"></div>';
            document.querySelector('.customizer-preview').appendChild(loadingSpinner);

            // remove loading spinner
            setTimeout(() => {
                loadingSpinner.remove();
            }, 1000);

            const urls = this.generateImageUrlsWithTemp();

            // Find all images and update them
            const previewImages = {
                front: document.querySelector('.customizer-preview--front .customizer-preview__image'),
                '45degree': document.querySelector('.customizer-preview--45degree .customizer-preview__image'),
                side: document.querySelector('.customizer-preview--side .customizer-preview__image'),
                back: document.querySelector('.customizer-preview--back .customizer-preview__image')
            };

            // Update each image
            Object.keys(previewImages).forEach(angle => {
                const img = previewImages[angle];
                if (img && urls[angle]) {
                    // Preload image before changing src to avoid flickering
                    const tempImage = new Image();
                    tempImage.onload = () => {
                        img.src = urls[angle];
                    };
                    tempImage.src = urls[angle];
                }
            });
        }

        generateImageUrlsWithTemp() {
            const { folder, version } = this.cloudinaryConfig;

            // Get model - use tempSelections if exists (model change in overlay), otherwise savedSelections
            const modelSKU = this.tempSelections['model'] || this.savedSelections['model'] || 'hs7uax';
            const model = this.normalizeModelNameFromSKU(modelSKU);

            // Photo angles
            const angles = ['front', '45degree', 'side', 'back'];

            // Get SKU - use tempSelections if exist, otherwise savedSelections
            const shellSKU = this.tempSelections['shell'] || this.savedSelections['shell'];
            const handleSKU = this.tempSelections['handle_color'] || this.savedSelections['handle_color'];
            const wheelSKU = this.tempSelections['wheel_caps'] || this.savedSelections['wheel_caps'];
            const tagSKU = this.getPreviewTagSku({ useTemp: true });

            console.log('🎨 generateImageUrlsWithTemp called:', {
                modelSKU,
                model,
                shellSKU,
                handleSKU,
                wheelSKU,
                tagSKU,
                tempSelections: { ...this.tempSelections },
                savedSelections: { ...this.savedSelections }
            });

            // Generate URL for each angle
            const urls = {};

            angles.forEach(angle => {
                // Base image ID
                const baseImageId = `v${version}/${folder}/${model}-${angle}`;

                // Overlay image IDs - different parts are visible on different angles
                const overlayImageIds = [];

                // Shell is visible on all angles
                if (shellSKU) {
                    overlayImageIds.push(`v${version}/${folder}/${shellSKU}-${angle}`);
                }

                // Handle is visible on all angles including interior
                if (handleSKU) {
                    overlayImageIds.push(`v${version}/${folder}/${handleSKU}-${angle}`);
                }

                // Wheel caps are visible on all angles
                if (wheelSKU) {
                    overlayImageIds.push(`v${version}/${folder}/${wheelSKU}-${angle}`);
                }

                // Luggage tag is visible mainly on front and 45degree
                if (tagSKU && ['front', '45degree'].includes(angle)) {
                    overlayImageIds.push(`v${version}/${folder}/${tagSKU}-${angle}`);
                }

                urls[angle] = this.getCloudinaryOverlaidImageUrl(baseImageId, overlayImageIds);
            });

            console.log('🎨 Generated URLs:', urls);
            return urls;
        }

        updatePriceDisplay() {
            let totalPrice = 0.0;

            // Sum prices of selected variants
            Object.keys(this.savedSelections).forEach(overlayType => {
                if (overlayType === 'model' || overlayType === 'model_slug' || overlayType === 'monogram_product') {
                    return; // Skip model for price calculation
                }
                const sku = this.savedSelections[overlayType];
                if (sku) {
                    console.log(overlayType, this.savedSelections[overlayType]);
                    let priceStr = this.getVariantPriceFromSKU(overlayType, sku);
                    if (overlayType === 'monogram') {
                        priceStr = this.getVariantPriceFromSKU('monogram_product', this.savedSelections['monogram_product']);
                    }
                    if (priceStr) {
                        const price = parseFloat(priceStr);
                        if (!isNaN(price)) {
                            totalPrice += price;
                        }
                    }
                    console.log(priceStr);
                }
            });

            // Update price display in summary panel
            this.priceContainer.textContent = `${totalPrice.toFixed(2)}`;
            this.finalPriceContainer.textContent = `${totalPrice.toFixed(2)}`;
        }

        getVariantPriceFromSKU(type, sku) {
            // Find variant ID from SKU by searching DOM elements
            const variantElement = document.querySelector(`.configurator-color-picker__swatch[data-option-name="${type}"][data-sku="${sku}"]`);
            if (variantElement) {
                return variantElement.getAttribute('data-price');
            }
            return null;
        }

        getVariantIdFromSKU(type, sku) {
            // Find variant ID from SKU by searching DOM elements
            const variantElement = document.querySelector(`.configurator-color-picker__swatch[data-option-name="${type}"][data-sku="${sku}"]`);
            if (variantElement) {
                return variantElement.getAttribute('data-id');
            }
            return null;
        }

        buildBundleItems() {
            // Build bundle items based on saved selections
            this.bundleItems = [];

            const bundleId = Date.now(); // Unique bundle ID for this configuration

            // Shell
            if (this.savedSelections['shell'] && this.getVariantIdFromSKU('shell', this.savedSelections['shell']) != null) {
                this.bundleItems.push({
                    'id': this.getVariantIdFromSKU('shell', this.savedSelections['shell']),
                    'quantity': 1,
                    'properties': {
                        "_bundleId": bundleId,
                        "_bundleParent": true,
                        "_hashParent": bundleId,
                        "_customized": "horizn-id"
                    }
                });
            }

            // Handle color
            if (this.savedSelections['handle_color'] && this.getVariantIdFromSKU('handle_color', this.savedSelections['handle_color']) != null) {
                this.bundleItems.push({
                    'id': this.getVariantIdFromSKU('handle_color', this.savedSelections['handle_color']),
                    'quantity': 1,
                    'properties': {
                        "_bundleId": bundleId,
                        "_hashChild": bundleId
                    }
                });
            }

            // Wheel caps
            if (this.savedSelections['wheel_caps'] && this.getVariantIdFromSKU('wheel_caps', this.savedSelections['wheel_caps']) != null) {
                this.bundleItems.push({
                    'id': this.getVariantIdFromSKU('wheel_caps', this.savedSelections['wheel_caps']),
                    'quantity': 1,
                    'properties': {
                        "_bundleId": bundleId,
                        "_hashChild": bundleId
                    }
                });
            }

            // Luggage tag
            if (this.savedSelections['luggage_tag'] && this.getVariantIdFromSKU('luggage_tag', this.savedSelections['luggage_tag']) != null) {
                this.bundleItems.push({
                    'id': this.getVariantIdFromSKU('luggage_tag', this.savedSelections['luggage_tag']),
                    'quantity': 1,
                    'properties': {
                        "_bundleId": bundleId,
                        "_hashChild": bundleId
                    }
                });
            }

            // Monogram
            if (this.savedSelections['monogram_product'] && this.getVariantIdFromSKU('monogram_product', this.savedSelections['monogram_product']) != null) {
                this.bundleItems.push({
                    'id': this.getVariantIdFromSKU('monogram_product', this.savedSelections['monogram_product']),
                    'quantity': 1,
                    'properties': {
                        "Monogram": this.savedSelections['monogram'],
                        "_bundleId": bundleId,
                        "_hashChild": bundleId,
                        "_excludeFromReturns": true
                    }
                });
            }
        }

        addToCart() {
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            const properties = {
                "Handle color": this.getVariantNameFromSKU(this.savedSelections['handle_color']),
                "Wheel caps": this.getVariantNameFromSKU(this.savedSelections['wheel_caps']),
                "Luggage tag": this.getLuggageTagLabelForCart(),
                "Monogram": this.savedSelections['monogram'],
            }

            const formData = {
                'items': this.bundleItems,
                'sections_url': window.location.pathname,
                'properties': properties
            };

            console.log('formData', formData);

            if (cart) {
                formData.sections = cart.getSectionsToRender().map((section) => section.id);
            }

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
                .then(response => {
                    return response.json();
                })
                .then((response) => {
                    console.log(response);
                    const variantKey = "_" + response.items[0].key;
                    const formData = {
                        'attributes': {
                            [variantKey]: JSON.stringify(properties)
                        }
                    };

                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                        .then(responseUpdate => {
                            return responseUpdate.json();
                        })
                        .then((responseUpdate) => {
                            console.log(responseUpdate);
                            const configuratorModal = document.querySelector('.configurator_modal');
                            if (configuratorModal) {
                                configuratorModal.style.display = 'none';
                            }

                            if (responseUpdate.status) {
                                console.error('Error:', responseUpdate.description);
                                return;
                            }

                            if (cart) {
                                if (cart.classList.contains('is-empty')) {
                                    cart.classList.remove('is-empty');
                                }
                                cart.renderContents(response);
                            }
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

    };
}

const initConfiguratorModal = () => {
    const configuratorModal = document.querySelector('.configurator_modal');
    const leaveModal = document.querySelector('.js-configurator-leave-modal');
    const openButtons = document.querySelectorAll('.configurator_button_open');
    const closeTrigger = document.querySelector('.js-configurator-close-trigger');
    const confirmCloseButton = document.querySelector('.js-close-modal');
    const leaveCancelButtons = document.querySelectorAll('.js-configurator-leave-cancel');

    if (!configuratorModal) {
        return;
    }

    const lockBodyScroll = () => {
        document.body.style.margin = '0';
        document.body.style.height = '100%';
        document.body.style.overflow = 'hidden';
    };

    const unlockBodyScroll = () => {
        document.body.style.height = 'auto';
        document.body.style.overflow = 'auto';
    };

    const openConfiguratorModal = () => {
        configuratorModal.style.display = 'block';
        lockBodyScroll();
    };

    const closeConfiguratorModal = () => {
        configuratorModal.style.display = 'none';
        unlockBodyScroll();
        hideLeaveModal();
    };

    const showLeaveModal = () => {
        if (!leaveModal) {
            return;
        }

        leaveModal.removeAttribute('hidden');
        leaveModal.setAttribute('aria-hidden', 'false');
        leaveModal.classList.add('configurator-leave-modal--visible');
    };

    const hideLeaveModal = () => {
        if (!leaveModal) {
            return;
        }

        leaveModal.setAttribute('hidden', '');
        leaveModal.setAttribute('aria-hidden', 'true');
        leaveModal.classList.remove('configurator-leave-modal--visible');
    };

    openButtons.forEach((button) => {
        button.addEventListener('click', openConfiguratorModal);
    });

    if (closeTrigger) {
        closeTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            showLeaveModal();
        });
    }

    if (confirmCloseButton) {
        confirmCloseButton.addEventListener('click', closeConfiguratorModal);
    }

    leaveCancelButtons.forEach((button) => {
        button.addEventListener('click', hideLeaveModal);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !leaveModal?.classList.contains('configurator-leave-modal--visible')) {
            return;
        }

        hideLeaveModal();
    });
};

// Initialize Configurator when DOM is ready or when called manually
const initConfigurator = () => {
    const configuratorElement = document.querySelector('.configurator');
    if (configuratorElement && !configuratorElement.configuratorInstance) {
        console.log("Configurator loaded");
        const configurator = new window.Configurator();
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initConfiguratorModal();
    initConfigurator();
});

// Export init function for manual initialization
window.initConfigurator = initConfigurator;
window.initConfiguratorModal = initConfiguratorModal;